import { render, staticRenderFns } from "./SjbqDetail.vue?vue&type=template&id=b5782e5e&scoped=true&"
import script from "./SjbqDetail.vue?vue&type=script&lang=js&"
export * from "./SjbqDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=b5782e5e&prod&scoped=true&lang=css&"
import style1 from "../detail.css?vue&type=style&index=1&id=b5782e5e&prod&scoped=true&lang=css&"
import style2 from "./SjbqDetail.vue?vue&type=style&index=2&id=b5782e5e&prod&scoped=true&lang=css&"
import style3 from "./SjbqDetail.vue?vue&type=style&index=3&id=b5782e5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5782e5e",
  null
  
)

export default component.exports